import { useEffect, useRef } from "react";

export const useTutorial = (driverObj) => {
  const observerRef = useRef(null);
  const driverRef = useRef(driverObj);

  // Actualizamos la referencia si cambia el objeto driver
  useEffect(() => {
    driverRef.current = driverObj;
  }, [driverObj]);

  const activeTutorial = () => {
    // Limpiamos cualquier tour anterior
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }
    
    // Iniciamos un nuevo tour después de un pequeño retraso
    setTimeout(() => {
      if (driverRef.current) {
        driverRef.current.drive();
        
        // Configuramos el observer para traducir "of" a "de"
        const observer = new MutationObserver(() => {
          const progressTextElements = document.querySelectorAll(
            ".driver-popover-progress-text"
          );
          progressTextElements.forEach((element) => {
            if (element.textContent.includes("of")) {
              element.textContent = element.textContent.replace("of", "de");
            }
          });
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });

        observerRef.current = observer;
      }
    }, 100);
  };

  // Limpieza al desmontar el componente
  useEffect(() => {
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
    };
  }, []);

  return { activeTutorial };
};

export default useTutorial;
